import styled from 'styled-components';
import { RichTextEditorInput } from './editor';
import { RichTextEditorValueType } from '../rich-text-editor/types';

interface Props {
  value?: RichTextEditorValueType;
}
export const RTEContent = styled(RichTextEditorInput).attrs({
  readonly: true,
})<Props>`
  .rte-editor {
    cursor: default;
    pointer-events: none;
    border: none;
    padding: 0;
    background-color: transparent;
  }
`;
